import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useVariancesList() {
    const toast = useToast()
    const records = ref(null)

    // Table Handler
    const columns = [
        { key: 'updated_at', label: 'Date', sortable: true },
        { key: 'barcode', label: 'Barcode', sortable: false },
        { key: 'purchased', label: 'Purch/KGs', sortable: false, thStyle: { width: "12%" }, thClass: 'text-right', tdClass: 'text-right' },
        { key: 'tfNumber', label: 'TF/Number', sortable: false },
        { key: 'previous', label: 'Prev/KGs', sortable: false, thStyle: { width: "12%" }, thClass: 'text-right', tdClass: 'text-right' },
        { key: 'scanned', label: 'Scan/KGs', sortable: false, thStyle: { width: "12%" }, thClass: 'text-right', tdClass: 'text-right' },
        { key: 'variance', label: 'Variance', sortable: false, thStyle: { width: "12%" }, thClass: 'text-right', tdClass: 'text-right' },
        { key: 'boughtVariance', label: 'Pur/Variance', sortable: false, thStyle: { width: "12%" }, thClass: 'text-right', tdClass: 'text-right' },
        { key: 'scanner', label: 'Scanner', sortable: false, thStyle: { width: "24%" }, thClass: 'text-left', tdClass: 'text-left' },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'action', label: 'Action', sortable: false },
    ]

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('updated_at')
    const isSortDirDesc = ref(false)

    const refetch = () => {
        records.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-variances/list', {
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { variations, meta } = response.data

                meta.value = meta

                callback(variations)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching variances list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveStatusVariant = status => {
        if (`${status}` === '1') return 'success'
        if (`${status}` === '0') return 'secondary'
        if (`${status}` === '-1') return 'danger'
    }

    return {
        fetch,
        refetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,

        resolveStatusVariant,
    }
}
